import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getNearsightedTrackListReportList } from 'models/nearsightedTrackReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/nearsighted-track-angle',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([NearsightedTrack]) => <NearsightedTrack />,
			onEnter: async ({ store, next }) => {
				console.log('on Nearsighted Track Page');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.NEARSIGHTED_TRACK}`);
				if (allowEnter) {
					await store.dispatch(getNearsightedTrackListReportList());
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
